import { useState, useRef } from 'react';
import API from '../utils/api';

export default function Import() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const fileRef = useRef();

  const handleImport = async () => {
    if (!file) return setError('اختر ملف أولاً');
    if (!file.name.endsWith('.xlsx')) return setError('الملف يجب أن يكون .xlsx');
    setLoading(true); setError(''); setResult(null);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await API.post('/import/excel', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setResult(res.data);
    } catch(e) {
      setError(e.response?.data?.error || 'حدث خطأ أثناء الاستيراد');
    } finally { setLoading(false); }
  };

  const handleExport = async () => {
    setExporting(true);
    try {
      const res = await API.get('/export/backup', { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      const date = new Date().toISOString().slice(0,10);
      a.download = `CRM_Backup_${date}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch(e) {
      setError('حدث خطأ أثناء التصدير');
    } finally { setExporting(false); }
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">📥 استيراد / تصدير البيانات</h1>
        <button className="btn btn-success" onClick={handleExport} disabled={exporting}>
          {exporting ? '⏳ جاري التصدير...' : '📤 تصدير نسخة احتياطية'}
        </button>
      </div>

      <div className="card mb-2" style={{borderRight:'4px solid var(--primary)'}}>
        <div className="card-title">📋 تعليمات الاستيراد</div>
        <div style={{fontSize:'0.875rem',lineHeight:2,color:'var(--text-muted)'}}>
          <div>✅ الملف يجب أن يحتوي على الشيتات التالية (بنفس الأسماء بالضبط):</div>
          <div style={{paddingRight:16,display:'flex',gap:8,flexWrap:'wrap',marginBottom:8}}>
            <span className="badge badge-info">المواد الأولية</span>
            <span className="badge badge-success">المنتجات النهائية</span>
            <span className="badge badge-primary">الوصفات BOM</span>
          </div>
          <div>⚠️ النظام لن يضيف مادة أو منتج إذا كان موجوداً مسبقاً (لا تكرار)</div>
          <div>⚠️ الترتيب: المواد أولاً ← ثم المنتجات ← ثم الوصفات</div>
          <div>💡 استخدم "تصدير نسخة احتياطية" لحفظ البيانات الحالية قبل أي تعديل</div>
        </div>
      </div>

      <div className="card">
        <div className="card-title">📁 رفع ملف الاستيراد</div>
        <div style={{display:'flex',gap:12,alignItems:'center',flexWrap:'wrap'}}>
          <input
            type="file" accept=".xlsx" ref={fileRef} style={{display:'none'}}
            onChange={e=>{ setFile(e.target.files[0]); setResult(null); setError(''); }}
          />
          <button className="btn btn-secondary" onClick={()=>fileRef.current.click()}>
            📂 اختر ملف Excel
          </button>
          {file && <span style={{fontSize:'0.875rem',color:'var(--text-muted)'}}>{file.name}</span>}
          {file && (
            <button className="btn btn-primary" onClick={handleImport} disabled={loading}>
              {loading ? '⏳ جاري الاستيراد...' : '📥 استيراد'}
            </button>
          )}
        </div>

        {error && <div className="alert alert-error mt-2">{error}</div>}

        {result && (
          <div className="alert alert-success mt-2">
            <div>{result.message}</div>
            <div style={{fontSize:'0.85rem',marginTop:6,display:'flex',gap:16,flexWrap:'wrap'}}>
              <span>📦 مواد أولية: <strong>{result.materials}</strong></span>
              <span>🎁 منتجات نهائية: <strong>{result.products}</strong></span>
              <span>🔗 وصفات BOM: <strong>{result.bom}</strong></span>
            </div>
            {result.errors?.length > 0 && (
              <div style={{marginTop:8,color:'#92400e',fontSize:'0.8rem'}}>
                <div>⚠️ أخطاء ({result.total_errors}):</div>
                {result.errors.map((e,i)=><div key={i}>- {e}</div>)}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
